var map = {
	"./Boton_Worksheets.svg": "3065",
	"./books.png": "37ab",
	"./dictionary.svg": "b31e",
	"./home.png": "32f0",
	"./info.svg": "22d8",
	"./language.png": "868a",
	"./laptop-computer.svg": "4d62",
	"./logout.png": "3d64",
	"./lupa.png": "34e6",
	"./new_menu_icons/Boton_Home.svg": "ed07",
	"./new_menu_icons/Boton_Practices.svg": "1b7c",
	"./new_menu_icons/Boton_dictionary.svg": "e4eb",
	"./new_menu_icons/Boton_e-library.svg": "ffb6",
	"./new_menu_icons/Boton_help.svg": "8f61",
	"./new_menu_icons/Boton_language.svg": "332e",
	"./new_menu_icons/Botón de búsqueda.svg": "b118",
	"./new_menu_icons/Sign_out_icono.svg": "6bcd",
	"./new_menu_icons/iconosHighSchool/206465A7.png": "fcbf",
	"./new_menu_icons/iconosHighSchool/4B5055E2.png": "527c",
	"./new_menu_icons/iconosHighSchool/5C511D5.png": "245e",
	"./new_menu_icons/iconosHighSchool/77B32350.png": "506f",
	"./new_menu_icons/iconosHighSchool/80E3A8D5.png": "4e5f",
	"./new_menu_icons/iconosHighSchool/8B22A79F.png": "d4a2",
	"./new_menu_icons/iconosHighSchool/Boton busqueda.svg": "04a7",
	"./new_menu_icons/iconosHighSchool/Boton cerrar.svg": "47b3",
	"./new_menu_icons/iconosHighSchool/Boton_Worksheets.svg": "d6e3",
	"./new_menu_icons/iconosHighSchool/Boton_sign_out.svg": "2841",
	"./new_menu_icons/iconosHighSchool/ECCBA3E3.png": "9cd4",
	"./new_menu_icons/iconosHighSchool/Fondo.svg": "c336",
	"./new_menu_icons/iconosHighSchool/Foto.svg": "4c1e",
	"./new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/206465A7.png": "ecb5",
	"./new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/4B5055E2.png": "3d12",
	"./new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/5C511D5.png": "c515",
	"./new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/77B32350.png": "9a11",
	"./new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/80E3A8D5.png": "de0c",
	"./new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/8B22A79F.png": "ccbe",
	"./new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/Boton_dictionary.svg": "e249",
	"./new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/Boton_help.svg": "3721",
	"./new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/Boton_home.svg": "11be",
	"./new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/Boton_language.svg": "ff33",
	"./new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/Boton_library.svg": "1402",
	"./new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/Boton_practice.svg": "90d3",
	"./new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/ECCBA3E3.png": "3a3d",
	"./new_menu_icons/iconosHighSchool/barra busqueda.svg": "217d",
	"./new_menu_icons/iconosMiddleSchool/Dictionary.svg": "c138",
	"./new_menu_icons/iconosMiddleSchool/Help.svg": "4553",
	"./new_menu_icons/iconosMiddleSchool/Home.svg": "213f",
	"./new_menu_icons/iconosMiddleSchool/Language.svg": "75cc",
	"./new_menu_icons/iconosMiddleSchool/MLms-02.svg": "55ec",
	"./new_menu_icons/iconosMiddleSchool/MLms-03.svg": "90d5",
	"./new_menu_icons/iconosMiddleSchool/MLms-04.svg": "7322",
	"./new_menu_icons/iconosMiddleSchool/MLms-05.svg": "849b",
	"./new_menu_icons/iconosMiddleSchool/MLms-06.svg": "4c41",
	"./new_menu_icons/iconosMiddleSchool/MLms-07.svg": "c171",
	"./new_menu_icons/iconosMiddleSchool/MLms-08.svg": "9a31",
	"./new_menu_icons/iconosMiddleSchool/MLms-09.svg": "fc21",
	"./new_menu_icons/iconosMiddleSchool/MLms-10.svg": "ab79",
	"./new_menu_icons/iconosMiddleSchool/MLms-11.svg": "246b",
	"./new_menu_icons/iconosMiddleSchool/MLms-12.svg": "239a1",
	"./new_menu_icons/iconosMiddleSchool/MLms-13.svg": "27d2",
	"./new_menu_icons/iconosMiddleSchool/Prectice.svg": "9c56",
	"./new_menu_icons/iconosMiddleSchool/avatarMLms_01.svg": "eb52",
	"./new_menu_icons/iconosMiddleSchool/e-library.svg": "1da13",
	"./play.png": "5c23",
	"./settings.svg": "a6d2",
	"./tutor/Icon_menu_1.svg": "ea0a",
	"./tutor/Icon_menu_2.svg": "3db3",
	"./tutor/Icon_menu_3.svg": "1cda",
	"./tutor/Icon_menu_4.svg": "4ed5",
	"./tutor/Icon_menu_5.svg": "0bab",
	"./tutor/Icon_menu_6.svg": "78bd",
	"./tutor/Icon_menu_logout.svg": "dd8b",
	"./tutor/Icon_menu_logout_Hover.svg": "7c5d",
	"./users.svg": "0731",
	"./windows_control/Close_1.svg": "be4a",
	"./windows_control/Close_2.svg": "027d",
	"./windows_control/maximize_1.svg": "a3dc",
	"./windows_control/maximize_2.svg": "9517",
	"./windows_control/minimize_1.svg": "4b35",
	"./windows_control/minimize_2.svg": "1504"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c2e1";